import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Eye, EyeOff } from "lucide-react";
import axios from "axios";
import "../styles/Login.css";
import logo from "../assets/kognitycs-logo.png";
import bgImage from "../assets/companylogo.png";

const Login = () => {
  const navigate = useNavigate();

  const [userId, setUserId] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");

  const handleLogin = async () => {
    setError("");

    try {
      const res = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/login`, {
        userId,
        password,
      });

      // ✅ STORE TOKEN
      localStorage.setItem("token", res.data.token);

      // 🔥 NORMALIZE ROLE HERE (THIS IS THE KEY FIX)
      const normalizedUser = {
        ...res.data.user,
        role:
          res.data.user.role?.toLowerCase() === "admin"
            ? "Admin"
            : "User",
      };

      localStorage.setItem("user", JSON.stringify(normalizedUser));

      // ✅ ROLE BASED REDIRECT
      if (normalizedUser.role === "Admin") {
        navigate("/admin", { replace: true });
      } else {
        navigate("/user", { replace: true });
      }
    } catch (err) {
      setError("Invalid User ID or Password");
    }
  };

  return (
    <div
      className="login-page"
      style={{ backgroundImage: `url(${bgImage})` }}
    >
      <div className="login-overlay"></div>

      <div className="login-center">
        <div className="login-card">
          <img src={logo} alt="Kognitycs Logo" className="login-logo" />

          <h2>
            Welcome Back <span>👋</span>
          </h2>
          <p className="subtitle">Please login to your account</p>

          {error && <p className="login-error">{error}</p>}

          <input
            type="text"
            placeholder="User ID"
            className="login-input"
            value={userId}
            onChange={(e) => setUserId(e.target.value)}
          />

          <div className="password-box">
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Password"
              className="login-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <span
              className="eye-icon"
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
            </span>
          </div>

          <button className="login-btn" onClick={handleLogin}>
            Login
          </button>

          <p
            className="forgot"
            onClick={() => navigate("/forgot-password")}
          >
            Forgot Password?
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;
